import { render, staticRenderFns } from "./journalOfEqSX.vue?vue&type=template&id=f5580752&scoped=true"
import script from "./journalOfEqSX.vue?vue&type=script&lang=js"
export * from "./journalOfEqSX.vue?vue&type=script&lang=js"
import style0 from "./journalOfEqSX.vue?vue&type=style&index=0&id=f5580752&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5580752",
  null
  
)

export default component.exports